import Vue from 'vue'
import App from './App.vue'
import router from './router'
import https from './assets/api/http.js'
import utils from './utils/utils'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import './assets/css/style.css'
import './assets/css/common.css'

Vue.config.productionTip = false
Vue.prototype.$api = https
Vue.prototype.$utils = utils
Vue.prototype.$layer = layer(Vue)

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
